// Generated RM/BASE attribute metadata from openEHR BMM
// Schema: rm v1.2.0
// BMM Version: 2.4
// Sources:
//   - https://raw.githubusercontent.com/openEHR/specifications-BASE/master/computable/BMM/openehr_base_1.3.0.bmm.json
//   - https://raw.githubusercontent.com/openEHR/specifications-RM/master/computable/BMM/openehr_rm_1.2.0.bmm.json
// Generated: 2026-09-16T18:15:54.769Z
//
// DO NOT EDIT THIS FILE DIRECTLY — regenerate with:
//   deno run --allow-read --allow-net --allow-write tasks/generate_rm_meta.ts
//

export interface RmClassMetaRow {
  isAbstract: boolean;
  ancestors: string[];
}

export interface RmAttributeMetaRow {
  name: string;
  typeName: string;
  min: number;
  max: number | null;
  mandatory: boolean;
  documentation?: string;
  polymorphic: boolean;
}

export const RM_META_SCHEMA_NAME = "rm";
export const RM_META_RM_RELEASE = "1.2.0";
export const RM_META_BMM_VERSION = "2.4";
export const RM_META_SOURCES: readonly string[] = [
  "https://raw.githubusercontent.com/openEHR/specifications-BASE/master/computable/BMM/openehr_base_1.3.0.bmm.json",
  "https://raw.githubusercontent.com/openEHR/specifications-RM/master/computable/BMM/openehr_rm_1.2.0.bmm.json"
];
export const RM_META_GENERATED_AT = "2026-09-16T18:15:54.769Z";

export const RM_CLASSES: Readonly<Record<string, RmClassMetaRow>> = {
  "Any": {
    "isAbstract": true,
    "ancestors": []
  },
  "Hash": {
    "isAbstract": false,
    "ancestors": [
      "Container"
    ]
  },
  "Container": {
    "isAbstract": true,
    "ancestors": [
      "Any"
    ]
  },
  "List": {
    "isAbstract": false,
    "ancestors": [
      "Container"
    ]
  },
  "Set": {
    "isAbstract": false,
    "ancestors": [
      "Container"
    ]
  },
  "Array": {
    "isAbstract": false,
    "ancestors": [
      "Container"
    ]
  },
  "Uri": {
    "isAbstract": false,
    "ancestors": [
      "String"
    ]
  },
  "Ordered_Numeric": {
    "isAbstract": true,
    "ancestors": [
      "Ordered",
      "Numeric"
    ]
  },
  "Integer": {
    "isAbstract": false,
    "ancestors": [
      "Ordered_Numeric"
    ]
  },
  "Double": {
    "isAbstract": false,
    "ancestors": [
      "Ordered_Numeric"
    ]
  },
  "Numeric": {
    "isAbstract": true,
    "ancestors": [
      "Any"
    ]
  },
  "Octet": {
    "isAbstract": false,
    "ancestors": [
      "Ordered"
    ]
  },
  "Character": {
    "isAbstract": false,
    "ancestors": [
      "Ordered"
    ]
  },
  "Boolean": {
    "isAbstract": false,
    "ancestors": [
      "Any"
    ]
  },
  "String": {
    "isAbstract": false,
    "ancestors": [
      "Ordered"
    ]
  },
  "Real": {
    "isAbstract": false,
    "ancestors": [
      "Ordered_Numeric"
    ]
  },
  "Integer64": {
    "isAbstract": false,
    "ancestors": [
      "Ordered_Numeric"
    ]
  },
  "Ordered": {
    "isAbstract": true,
    "ancestors": [
      "Any"
    ]
  },
  "Iso8601_date_time": {
    "isAbstract": false,
    "ancestors": [
      "Iso8601_type"
    ]
  },
  "Iso8601_duration": {
    "isAbstract": false,
    "ancestors": [
      "Iso8601_type"
    ]
  },
  "Iso8601_time": {
    "isAbstract": false,
    "ancestors": [
      "Iso8601_type"
    ]
  },
  "Iso8601_type": {
    "isAbstract": true,
    "ancestors": [
      "Temporal",
      "Time_Definitions"
    ]
  },
  "Iso8601_date": {
    "isAbstract": false,
    "ancestors": [
      "Iso8601_type"
    ]
  },
  "Temporal": {
    "isAbstract": true,
    "ancestors": [
      "Ordered"
    ]
  },
  "Multiplicity_interval": {
    "isAbstract": false,
    "ancestors": [
      "Proper_interval"
    ]
  },
  "Interval": {
    "isAbstract": true,
    "ancestors": [
      "Any"
    ]
  },
  "Cardinality": {
    "isAbstract": false,
    "ancestors": []
  },
  "Terminology_code": {
    "isAbstract": false,
    "ancestors": [
      "Any"
    ]
  },
  "Terminology_term": {
    "isAbstract": false,
    "ancestors": [
      "Any"
    ]
  },
  "ARCHETYPE_ID": {
    "isAbstract": false,
    "ancestors": [
      "OBJECT_ID"
    ]
  },
  "GENERIC_ID": {
    "isAbstract": false,
    "ancestors": [
      "OBJECT_ID"
    ]
  },
  "HIER_OBJECT_ID": {
    "isAbstract": false,
    "ancestors": [
      "UID_BASED_ID"
    ]
  },
  "LOCATABLE_REF": {
    "isAbstract": false,
    "ancestors": [
      "OBJECT_REF"
    ]
  },
  "OBJECT_ID": {
    "isAbstract": true,
    "ancestors": []
  },
  "OBJECT_REF": {
    "isAbstract": false,
    "ancestors": []
  },
  "OBJECT_VERSION_ID": {
    "isAbstract": false,
    "ancestors": [
      "UID_BASED_ID"
    ]
  },
  "PARTY_REF": {
    "isAbstract": false,
    "ancestors": [
      "OBJECT_REF"
    ]
  },
  "TERMINOLOGY_ID": {
    "isAbstract": false,
    "ancestors": [
      "OBJECT_ID"
    ]
  },
  "VERSION_TREE_ID": {
    "isAbstract": false,
    "ancestors": []
  },
  "UID_BASED_ID": {
    "isAbstract": true,
    "ancestors": [
      "OBJECT_ID"
    ]
  },
  "UUID": {
    "isAbstract": false,
    "ancestors": [
      "UID"
    ]
  },
  "INTERNET_ID": {
    "isAbstract": false,
    "ancestors": [
      "UID"
    ]
  },
  "UID": {
    "isAbstract": true,
    "ancestors": []
  },
  "ISO_OID": {
    "isAbstract": false,
    "ancestors": [
      "UID"
    ]
  },
  "TEMPLATE_ID": {
    "isAbstract": false,
    "ancestors": [
      "OBJECT_ID"
    ]
  },
  "ACCESS_GROUP_REF": {
    "isAbstract": false,
    "ancestors": [
      "OBJECT_REF"
    ]
  },
  "OPENEHR_DEFINITIONS": {
    "isAbstract": false,
    "ancestors": [
      "BASIC_DEFINITIONS"
    ]
  },
  "BASIC_DEFINITIONS": {
    "isAbstract": false,
    "ancestors": []
  },
  "VALIDITY_KIND": {
    "isAbstract": false,
    "ancestors": [
      "String"
    ]
  },
  "VERSION_STATUS": {
    "isAbstract": false,
    "ancestors": [
      "String"
    ]
  },
  "Env": {
    "isAbstract": false,
    "ancestors": []
  },
  "Statistical_evaluator": {
    "isAbstract": false,
    "ancestors": []
  },
  "Locale": {
    "isAbstract": false,
    "ancestors": []
  },
  "Math": {
    "isAbstract": false,
    "ancestors": []
  },
  "Quantity_converter": {
    "isAbstract": false,
    "ancestors": []
  },
  "Comparable": {
    "isAbstract": true,
    "ancestors": []
  },
  "TUPLE": {
    "isAbstract": false,
    "ancestors": []
  },
  "FUNCTION": {
    "isAbstract": false,
    "ancestors": [
      "ROUTINE"
    ]
  },
  "TUPLE1": {
    "isAbstract": false,
    "ancestors": [
      "TUPLE"
    ]
  },
  "TUPLE2": {
    "isAbstract": false,
    "ancestors": [
      "TUPLE"
    ]
  },
  "ROUTINE": {
    "isAbstract": false,
    "ancestors": []
  },
  "PROCEDURE": {
    "isAbstract": false,
    "ancestors": [
      "ROUTINE"
    ]
  },
  "Iso8601_timezone": {
    "isAbstract": false,
    "ancestors": [
      "Iso8601_type"
    ]
  },
  "Time_Definitions": {
    "isAbstract": false,
    "ancestors": []
  },
  "Proper_interval": {
    "isAbstract": false,
    "ancestors": [
      "Interval"
    ]
  },
  "Point_interval": {
    "isAbstract": false,
    "ancestors": [
      "Interval"
    ]
  },
  "CODE_PHRASE": {
    "isAbstract": false,
    "ancestors": []
  },
  "AUTHORED_RESOURCE": {
    "isAbstract": true,
    "ancestors": []
  },
  "RESOURCE_DESCRIPTION": {
    "isAbstract": false,
    "ancestors": []
  },
  "TRANSLATION_DETAILS": {
    "isAbstract": false,
    "ancestors": []
  },
  "RESOURCE_DESCRIPTION_ITEM": {
    "isAbstract": false,
    "ancestors": []
  },
  "RESOURCE_ANNOTATIONS": {
    "isAbstract": false,
    "ancestors": []
  },
  "PATHABLE": {
    "isAbstract": true,
    "ancestors": [
      "Any"
    ]
  },
  "LINK": {
    "isAbstract": false,
    "ancestors": []
  },
  "LOCATABLE": {
    "isAbstract": true,
    "ancestors": [
      "PATHABLE"
    ]
  },
  "ARCHETYPED": {
    "isAbstract": false,
    "ancestors": []
  },
  "FEEDER_AUDIT": {
    "isAbstract": false,
    "ancestors": []
  },
  "FEEDER_AUDIT_DETAILS": {
    "isAbstract": false,
    "ancestors": []
  },
  "VERSIONED_OBJECT": {
    "isAbstract": false,
    "ancestors": []
  },
  "CONTRIBUTION": {
    "isAbstract": false,
    "ancestors": []
  },
  "VERSION": {
    "isAbstract": true,
    "ancestors": []
  },
  "IMPORTED_VERSION": {
    "isAbstract": false,
    "ancestors": [
      "VERSION"
    ]
  },
  "ORIGINAL_VERSION": {
    "isAbstract": false,
    "ancestors": [
      "VERSION"
    ]
  },
  "REVISION_HISTORY_ITEM": {
    "isAbstract": false,
    "ancestors": []
  },
  "AUDIT_DETAILS": {
    "isAbstract": false,
    "ancestors": []
  },
  "ATTESTATION": {
    "isAbstract": false,
    "ancestors": [
      "AUDIT_DETAILS"
    ]
  },
  "PARTICIPATION": {
    "isAbstract": false,
    "ancestors": []
  },
  "PARTY_PROXY": {
    "isAbstract": true,
    "ancestors": []
  },
  "PARTY_IDENTIFIED": {
    "isAbstract": false,
    "ancestors": [
      "PARTY_PROXY"
    ]
  },
  "PARTY_SELF": {
    "isAbstract": false,
    "ancestors": [
      "PARTY_PROXY"
    ]
  },
  "PARTY_RELATED": {
    "isAbstract": false,
    "ancestors": [
      "PARTY_IDENTIFIED"
    ]
  },
  "REVISION_HISTORY": {
    "isAbstract": false,
    "ancestors": []
  },
  "VERSIONED_FOLDER": {
    "isAbstract": false,
    "ancestors": [
      "VERSIONED_OBJECT"
    ]
  },
  "FOLDER": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "ITEM_TAG": {
    "isAbstract": false,
    "ancestors": []
  },
  "DATA_STRUCTURE": {
    "isAbstract": true,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "ITEM_STRUCTURE": {
    "isAbstract": true,
    "ancestors": [
      "DATA_STRUCTURE"
    ]
  },
  "ITEM_TREE": {
    "isAbstract": false,
    "ancestors": [
      "ITEM_STRUCTURE"
    ]
  },
  "ITEM_SINGLE": {
    "isAbstract": false,
    "ancestors": [
      "ITEM_STRUCTURE"
    ]
  },
  "ITEM_TABLE": {
    "isAbstract": false,
    "ancestors": [
      "ITEM_STRUCTURE"
    ]
  },
  "ITEM_LIST": {
    "isAbstract": false,
    "ancestors": [
      "ITEM_STRUCTURE"
    ]
  },
  "EVENT": {
    "isAbstract": true,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "POINT_EVENT": {
    "isAbstract": false,
    "ancestors": [
      "EVENT"
    ]
  },
  "INTERVAL_EVENT": {
    "isAbstract": false,
    "ancestors": [
      "EVENT"
    ]
  },
  "HISTORY": {
    "isAbstract": false,
    "ancestors": [
      "DATA_STRUCTURE"
    ]
  },
  "ITEM": {
    "isAbstract": true,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "CLUSTER": {
    "isAbstract": false,
    "ancestors": [
      "ITEM"
    ]
  },
  "ELEMENT": {
    "isAbstract": false,
    "ancestors": [
      "ITEM"
    ]
  },
  "DATA_VALUE": {
    "isAbstract": true,
    "ancestors": [
      "OPENEHR_DEFINITIONS"
    ]
  },
  "DV_BOOLEAN": {
    "isAbstract": false,
    "ancestors": [
      "DATA_VALUE"
    ]
  },
  "DV_STATE": {
    "isAbstract": false,
    "ancestors": [
      "DATA_VALUE"
    ]
  },
  "DV_IDENTIFIER": {
    "isAbstract": false,
    "ancestors": [
      "DATA_VALUE"
    ]
  },
  "DV_ENCAPSULATED": {
    "isAbstract": true,
    "ancestors": [
      "DATA_VALUE"
    ]
  },
  "DV_MULTIMEDIA": {
    "isAbstract": false,
    "ancestors": [
      "DV_ENCAPSULATED"
    ]
  },
  "DV_PARSABLE": {
    "isAbstract": false,
    "ancestors": [
      "DV_ENCAPSULATED"
    ]
  },
  "DV_PARAGRAPH": {
    "isAbstract": false,
    "ancestors": [
      "DATA_VALUE"
    ]
  },
  "DV_TEXT": {
    "isAbstract": false,
    "ancestors": [
      "DATA_VALUE"
    ]
  },
  "DV_CODED_TEXT": {
    "isAbstract": false,
    "ancestors": [
      "DV_TEXT"
    ]
  },
  "TERM_MAPPING": {
    "isAbstract": false,
    "ancestors": []
  },
  "DV_ORDERED": {
    "isAbstract": true,
    "ancestors": [
      "DATA_VALUE",
      "Ordered"
    ]
  },
  "DV_INTERVAL": {
    "isAbstract": false,
    "ancestors": [
      "DATA_VALUE",
      "Interval"
    ]
  },
  "REFERENCE_RANGE": {
    "isAbstract": false,
    "ancestors": []
  },
  "DV_QUANTIFIED": {
    "isAbstract": true,
    "ancestors": [
      "DV_ORDERED"
    ]
  },
  "DV_PROPORTION": {
    "isAbstract": false,
    "ancestors": [
      "PROPORTION_KIND",
      "DV_AMOUNT"
    ]
  },
  "PROPORTION_KIND": {
    "isAbstract": false,
    "ancestors": [
      "Integer"
    ]
  },
  "DV_AMOUNT": {
    "isAbstract": true,
    "ancestors": [
      "DV_QUANTIFIED"
    ]
  },
  "DV_QUANTITY": {
    "isAbstract": false,
    "ancestors": [
      "DV_AMOUNT"
    ]
  },
  "DV_COUNT": {
    "isAbstract": false,
    "ancestors": [
      "DV_AMOUNT"
    ]
  },
  "DV_ABSOLUTE_QUANTITY": {
    "isAbstract": true,
    "ancestors": [
      "DV_QUANTIFIED"
    ]
  },
  "DV_ORDINAL": {
    "isAbstract": false,
    "ancestors": [
      "DV_ORDERED"
    ]
  },
  "DV_SCALE": {
    "isAbstract": false,
    "ancestors": [
      "DV_ORDERED"
    ]
  },
  "DV_DURATION": {
    "isAbstract": false,
    "ancestors": [
      "DV_AMOUNT",
      "Iso8601_duration"
    ]
  },
  "DV_TEMPORAL": {
    "isAbstract": true,
    "ancestors": [
      "DV_ABSOLUTE_QUANTITY"
    ]
  },
  "DV_DATE": {
    "isAbstract": false,
    "ancestors": [
      "DV_TEMPORAL",
      "Iso8601_date"
    ]
  },
  "DV_TIME": {
    "isAbstract": false,
    "ancestors": [
      "DV_TEMPORAL",
      "Iso8601_time"
    ]
  },
  "DV_DATE_TIME": {
    "isAbstract": false,
    "ancestors": [
      "DV_TEMPORAL",
      "Iso8601_date_time"
    ]
  },
  "DV_TIME_SPECIFICATION": {
    "isAbstract": true,
    "ancestors": [
      "DATA_VALUE"
    ]
  },
  "DV_PERIODIC_TIME_SPECIFICATION": {
    "isAbstract": false,
    "ancestors": [
      "DV_TIME_SPECIFICATION"
    ]
  },
  "DV_GENERAL_TIME_SPECIFICATION": {
    "isAbstract": false,
    "ancestors": [
      "DV_TIME_SPECIFICATION"
    ]
  },
  "DV_URI": {
    "isAbstract": false,
    "ancestors": [
      "DATA_VALUE"
    ]
  },
  "DV_EHR_URI": {
    "isAbstract": false,
    "ancestors": [
      "DV_URI"
    ]
  },
  "EXTERNAL_ENVIRONMENT_ACCESS": {
    "isAbstract": true,
    "ancestors": [
      "TERMINOLOGY_SERVICE",
      "MEASUREMENT_SERVICE"
    ]
  },
  "MEASUREMENT_SERVICE": {
    "isAbstract": false,
    "ancestors": []
  },
  "OPENEHR_TERMINOLOGY_GROUP_IDENTIFIERS": {
    "isAbstract": false,
    "ancestors": []
  },
  "OPENEHR_CODE_SET_IDENTIFIERS": {
    "isAbstract": false,
    "ancestors": []
  },
  "TERMINOLOGY_SERVICE": {
    "isAbstract": false,
    "ancestors": [
      "OPENEHR_TERMINOLOGY_GROUP_IDENTIFIERS",
      "OPENEHR_CODE_SET_IDENTIFIERS"
    ]
  },
  "CODE_SET_ACCESS": {
    "isAbstract": false,
    "ancestors": []
  },
  "TERMINOLOGY_ACCESS": {
    "isAbstract": false,
    "ancestors": []
  },
  "EHR": {
    "isAbstract": false,
    "ancestors": []
  },
  "VERSIONED_EHR_ACCESS": {
    "isAbstract": false,
    "ancestors": [
      "VERSIONED_OBJECT"
    ]
  },
  "VERSIONED_EHR_STATUS": {
    "isAbstract": false,
    "ancestors": [
      "VERSIONED_OBJECT"
    ]
  },
  "VERSIONED_COMPOSITION": {
    "isAbstract": false,
    "ancestors": [
      "VERSIONED_OBJECT"
    ]
  },
  "EHR_ACCESS": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "EHR_STATUS": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "ACCESS_CONTROL_SETTINGS": {
    "isAbstract": true,
    "ancestors": []
  },
  "EXTRACT": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "EXTRACT_ACTION_REQUEST": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "EXTRACT_CHAPTER": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "EXTRACT_CONTENT_ITEM": {
    "isAbstract": true,
    "ancestors": [
      "EXTRACT_ITEM"
    ]
  },
  "EXTRACT_ENTITY_CHAPTER": {
    "isAbstract": false,
    "ancestors": [
      "EXTRACT_CHAPTER"
    ]
  },
  "EXTRACT_ENTITY_MANIFEST": {
    "isAbstract": false,
    "ancestors": []
  },
  "EXTRACT_ERROR": {
    "isAbstract": false,
    "ancestors": []
  },
  "EXTRACT_FOLDER": {
    "isAbstract": false,
    "ancestors": [
      "EXTRACT_ITEM"
    ]
  },
  "EXTRACT_ITEM": {
    "isAbstract": true,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "EXTRACT_MANIFEST": {
    "isAbstract": false,
    "ancestors": []
  },
  "EXTRACT_PARTICIPATION": {
    "isAbstract": false,
    "ancestors": []
  },
  "EXTRACT_REQUEST": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "EXTRACT_SPEC": {
    "isAbstract": false,
    "ancestors": []
  },
  "EXTRACT_UPDATE_SPEC": {
    "isAbstract": false,
    "ancestors": []
  },
  "EXTRACT_VERSION_SPEC": {
    "isAbstract": false,
    "ancestors": []
  },
  "OPENEHR_CONTENT_ITEM": {
    "isAbstract": false,
    "ancestors": [
      "EXTRACT_CONTENT_ITEM"
    ]
  },
  "X_VERSIONED_OBJECT": {
    "isAbstract": false,
    "ancestors": []
  },
  "X_VERSIONED_EHR_ACCESS": {
    "isAbstract": false,
    "ancestors": [
      "X_VERSIONED_OBJECT"
    ]
  },
  "X_VERSIONED_EHR_STATUS": {
    "isAbstract": false,
    "ancestors": [
      "X_VERSIONED_OBJECT"
    ]
  },
  "X_VERSIONED_COMPOSITION": {
    "isAbstract": false,
    "ancestors": [
      "X_VERSIONED_OBJECT"
    ]
  },
  "X_VERSIONED_FOLDER": {
    "isAbstract": false,
    "ancestors": [
      "X_VERSIONED_OBJECT"
    ]
  },
  "X_VERSIONED_PARTY": {
    "isAbstract": false,
    "ancestors": [
      "X_VERSIONED_OBJECT"
    ]
  },
  "GENERIC_CONTENT_ITEM": {
    "isAbstract": false,
    "ancestors": [
      "EXTRACT_CONTENT_ITEM"
    ]
  },
  "SYNC_EXTRACT_REQUEST": {
    "isAbstract": false,
    "ancestors": [
      "MESSAGE_CONTENT"
    ]
  },
  "SYNC_EXTRACT": {
    "isAbstract": false,
    "ancestors": [
      "MESSAGE_CONTENT"
    ]
  },
  "X_CONTRIBUTION": {
    "isAbstract": false,
    "ancestors": []
  },
  "SYNC_EXTRACT_SPEC": {
    "isAbstract": false,
    "ancestors": []
  },
  "MESSAGE": {
    "isAbstract": false,
    "ancestors": []
  },
  "ADDRESSED_MESSAGE": {
    "isAbstract": false,
    "ancestors": []
  },
  "MESSAGE_CONTENT": {
    "isAbstract": true,
    "ancestors": []
  },
  "PARTY": {
    "isAbstract": true,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "CONTACT": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "ADDRESS": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "PARTY_IDENTITY": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "ROLE": {
    "isAbstract": false,
    "ancestors": [
      "PARTY"
    ]
  },
  "ACTOR": {
    "isAbstract": true,
    "ancestors": [
      "PARTY"
    ]
  },
  "CAPABILITY": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "AGENT": {
    "isAbstract": false,
    "ancestors": [
      "ACTOR"
    ]
  },
  "ORGANISATION": {
    "isAbstract": false,
    "ancestors": [
      "ACTOR"
    ]
  },
  "GROUP": {
    "isAbstract": false,
    "ancestors": [
      "ACTOR"
    ]
  },
  "PERSON": {
    "isAbstract": false,
    "ancestors": [
      "ACTOR"
    ]
  },
  "PARTY_RELATIONSHIP": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "VERSIONED_PARTY": {
    "isAbstract": false,
    "ancestors": [
      "VERSIONED_OBJECT"
    ]
  },
  "GENERIC_ENTRY": {
    "isAbstract": false,
    "ancestors": [
      "CONTENT_ITEM"
    ]
  },
  "COMPOSITION": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "EVENT_CONTEXT": {
    "isAbstract": false,
    "ancestors": [
      "PATHABLE"
    ]
  },
  "CONTENT_ITEM": {
    "isAbstract": true,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "SECTION": {
    "isAbstract": false,
    "ancestors": [
      "CONTENT_ITEM"
    ]
  },
  "ADMIN_ENTRY": {
    "isAbstract": false,
    "ancestors": [
      "ENTRY"
    ]
  },
  "CARE_ENTRY": {
    "isAbstract": true,
    "ancestors": [
      "ENTRY"
    ]
  },
  "OBSERVATION": {
    "isAbstract": false,
    "ancestors": [
      "CARE_ENTRY"
    ]
  },
  "EVALUATION": {
    "isAbstract": false,
    "ancestors": [
      "CARE_ENTRY"
    ]
  },
  "ACTION": {
    "isAbstract": false,
    "ancestors": [
      "CARE_ENTRY"
    ]
  },
  "ACTIVITY": {
    "isAbstract": false,
    "ancestors": [
      "LOCATABLE"
    ]
  },
  "ISM_TRANSITION": {
    "isAbstract": false,
    "ancestors": [
      "PATHABLE"
    ]
  },
  "INSTRUCTION_DETAILS": {
    "isAbstract": false,
    "ancestors": [
      "PATHABLE"
    ]
  },
  "ENTRY": {
    "isAbstract": true,
    "ancestors": [
      "CONTENT_ITEM"
    ]
  },
  "INSTRUCTION": {
    "isAbstract": false,
    "ancestors": [
      "CARE_ENTRY"
    ]
  }
};

export const RM_OWN_ATTRIBUTES: Readonly<
  Record<string, readonly RmAttributeMetaRow[]>
> = {
  "Iso8601_type": [
    {
      "name": "value",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Representation of all descendants is a single String."
    }
  ],
  "Interval": [
    {
      "name": "lower",
      "typeName": "T",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Lower bound."
    },
    {
      "name": "lower_included",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if `_lower_` boundary value included in range, if `not _lower_unbounded_`."
    },
    {
      "name": "lower_unbounded",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if `_lower_` boundary open (i.e. = `-infinity`)."
    },
    {
      "name": "upper",
      "typeName": "T",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Upper bound."
    },
    {
      "name": "upper_included",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if `_upper_` boundary value included in range if `not _upper_unbounded_`."
    },
    {
      "name": "upper_unbounded",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if `_upper_` boundary open (i.e. = `+infinity`)."
    }
  ],
  "Cardinality": [
    {
      "name": "interval",
      "typeName": "Multiplicity_interval",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The interval of this cardinality. "
    },
    {
      "name": "is_ordered",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if the members of the container attribute to which this cardinality refers are ordered. "
    },
    {
      "name": "is_unique",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if the members of the container attribute to which this cardinality refers are unique."
    }
  ],
  "Terminology_code": [
    {
      "name": "code_string",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "A terminology code or post-coordinated code expression, if supported by the terminology. The code may refer to a single term, a value set consisting of multiple terms, or some other entity representable within the terminology."
    },
    {
      "name": "terminology_id",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The archetype environment namespace identifier used to identify a terminology. Typically a value like `\"snomed_ct\"` that is mapped elsewhere to the full URI identifying the terminology."
    },
    {
      "name": "terminology_version",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional string value representing terminology version, typically a date or dotted numeric."
    },
    {
      "name": "uri",
      "typeName": "Uri",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The URI reference that may be used as a concrete key into a notional terminology service for queries that can obtain the term text, definition, and other associated elements."
    }
  ],
  "Terminology_term": [
    {
      "name": "concept",
      "typeName": "Terminology_code",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Reference to the terminology concept formally representing this term."
    },
    {
      "name": "text",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Text of term."
    }
  ],
  "GENERIC_ID": [
    {
      "name": "scheme",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Name of the scheme to which this identifier conforms. Ideally this name will be recognisable globally but realistically it may be a local ad hoc scheme whose name is not controlled or standardised in any way. "
    }
  ],
  "LOCATABLE_REF": [
    {
      "name": "id",
      "typeName": "UID_BASED_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Globally unique id of an object, regardless of where it is stored."
    },
    {
      "name": "path",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The path to an instance, as an absolute path with respect to the object found at `VERSION._data_`. An empty path means that the object referred to by `_id_` is being specified. "
    }
  ],
  "OBJECT_ID": [
    {
      "name": "value",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The value of the id in the form defined below. "
    }
  ],
  "OBJECT_REF": [
    {
      "name": "id",
      "typeName": "OBJECT_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Globally unique id of an object, regardless of where it is stored."
    },
    {
      "name": "namespace",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Namespace to which this identifier belongs in the local system context (and possibly in any other openEHR compliant environment) e.g.  terminology ,  demographic . These names are not yet standardised. Legal values for `_namespace_` are:\n\n* `\"local\"`\n* `\"unknown\"`\n* a string matching the standard regex `[a-zA-Z][a-zA-Z0-9_.:\\/&?=+-]*`.\n\nNote that the first two are just special values of the regex, and will be matched by it."
    },
    {
      "name": "type",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Name of the  class (concrete or abstract) of object to which this identifier type refers, e.g. `PARTY`, `PERSON`,  `GUIDELINE`  etc. These class names are from the relevant reference model. The type name `ANY` can be used to indicate that any type is accepted (e.g. if the type is unknown). "
    }
  ],
  "VERSION_TREE_ID": [
    {
      "name": "value",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "String form of this identifier."
    }
  ],
  "UID": [
    {
      "name": "value",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The value of the id."
    }
  ],
  "Point_interval": [
    {
      "name": "lower_included",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Lower boundary value included in range if not `_lower_unbounded_`."
    },
    {
      "name": "lower_unbounded",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Lower boundary open (i.e. = -infinity)."
    },
    {
      "name": "upper_included",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Upper boundary value included in range if not `_upper_unbounded_`."
    },
    {
      "name": "upper_unbounded",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Upper boundary open (i.e. = +infinity)."
    }
  ],
  "CODE_PHRASE": [
    {
      "name": "code_string",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The key used by the terminology service to identify a concept or coordination of concepts. This string is most likely parsable inside the terminology service, but nothing can be assumed about its syntax outside that context. "
    },
    {
      "name": "preferred_term",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional attribute to carry preferred term corresponding to the code or expression in `_code_string_`. Typical use in integration situations which create mappings, and representing data for which both a (non-preferred) actual term and a preferred term are both required."
    },
    {
      "name": "terminology_id",
      "typeName": "TERMINOLOGY_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Identifier of the distinct terminology from which the code_string (or its elements) was extracted."
    }
  ],
  "AUTHORED_RESOURCE": [
    {
      "name": "description",
      "typeName": "RESOURCE_DESCRIPTION",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Description and lifecycle information of the resource."
    },
    {
      "name": "is_controlled",
      "typeName": "Boolean",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "True if this resource is under any kind of change control (even file copying), in which case revision history is created. "
    },
    {
      "name": "original_language",
      "typeName": "CODE_PHRASE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Language in which this resource was initially authored. Although there is no language primacy of resources overall, the language of original authoring is required to ensure natural language translations can preserve quality. Language is relevant in both the description and ontology sections. "
    },
    {
      "name": "revision_history",
      "typeName": "REVISION_HISTORY",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The revision history of the resource. Only required if `_is_controlled_ = True` (avoids large revision histories for informal or private editing situations). "
    },
    {
      "name": "translations",
      "typeName": "Hash<String, TRANSLATION_DETAILS>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "List of details for each natural-language translation made of this resource, keyed by language. For each translation listed here, there must be corresponding sections in all language-dependent parts of the resource. The `_original_language_` does not appear in this list."
    }
  ],
  "RESOURCE_DESCRIPTION": [
    {
      "name": "details",
      "typeName": "Hash<String, RESOURCE_DESCRIPTION_ITEM>",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Details of all parts of resource description that are natural language-dependent, keyed by language code. "
    },
    {
      "name": "lifecycle_state",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Lifecycle state of the resource, typically including states such as: `initial | submitted | experimental | awaiting_approval | approved | superseded | obsolete`."
    },
    {
      "name": "original_author",
      "typeName": "Hash<String, String>",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Original author of this resource, with all relevant details, including organisation."
    },
    {
      "name": "other_contributors",
      "typeName": "List<String>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Other contributors to the resource, probably listed in  `'name <email>'`  form. "
    },
    {
      "name": "other_details",
      "typeName": "Hash<String, String>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Additional non language-sensitive resource meta-data, as a list of name/value pairs. "
    },
    {
      "name": "parent_resource",
      "typeName": "AUTHORED_RESOURCE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Reference to owning resource. "
    },
    {
      "name": "resource_package_uri",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "URI of package to which this resource belongs."
    }
  ],
  "TRANSLATION_DETAILS": [
    {
      "name": "accreditaton",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Accreditation of translator, usually a national translator's registration or association membership id."
    },
    {
      "name": "author",
      "typeName": "Hash<String, String>",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Translator name and other demographic details."
    },
    {
      "name": "language",
      "typeName": "CODE_PHRASE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Language of the translation."
    },
    {
      "name": "other_details",
      "typeName": "Hash<String, String>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Any other meta-data."
    }
  ],
  "RESOURCE_DESCRIPTION_ITEM": [
    {
      "name": "copyright",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional copyright statement for the resource as a knowledge resource. \n"
    },
    {
      "name": "keywords",
      "typeName": "List<String>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Keywords which characterise this resource, used e.g. for indexing and searching. "
    },
    {
      "name": "language",
      "typeName": "CODE_PHRASE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The localised language in which the items in this description item are written. Coded from openEHR code set `languages`."
    },
    {
      "name": "misuse",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Description of any misuses of the resource, i.e. contexts in which it should not be used."
    },
    {
      "name": "original_resource_uri",
      "typeName": "Hash<String, String>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "URIs of original clinical document(s) or description of which resource is a formalisation, in the language of this description item; keyed by meaning. "
    },
    {
      "name": "other_details",
      "typeName": "Hash<String, String>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Additional language-sensitive resource metadata, as a list of name/value pairs. "
    },
    {
      "name": "purpose",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Purpose of the resource."
    },
    {
      "name": "use",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Description of the uses of the resource, i.e. contexts in which it could be used. \n"
    }
  ],
  "RESOURCE_ANNOTATIONS": [
    {
      "name": "documentation",
      "typeName": "Hash",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Documentary annotations in a multi-level keyed structure."
    }
  ],
  "LINK": [
    {
      "name": "meaning",
      "typeName": "DV_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Used to describe the relationship, usually in clinical terms, such as  in response to  (the relationship between test results and an order),  follow-up to  and so on. Such relationships can represent any clinically meaningful connection between pieces of information. Values for meaning include those described in Annex C, ENV 13606 pt 2 under the categories of  generic ,  documenting and reporting ,  organisational ,  clinical ,  circumstancial , and  view management ."
    },
    {
      "name": "target",
      "typeName": "DV_EHR_URI",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The logical  to  object in the link relation, as per the linguistic sense of the meaning attribute."
    },
    {
      "name": "type",
      "typeName": "DV_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The type attribute is used to indicate a clinical or domain-level meaning for the kind of link, for example  problem  or  issue . If type values are designed appropriately, they can be used by the requestor of EHR extracts to categorise links which must be followed and which can be broken when the extract is created. \n"
    }
  ],
  "LOCATABLE": [
    {
      "name": "archetype_details",
      "typeName": "ARCHETYPED",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Details of archetyping used on this node."
    },
    {
      "name": "archetype_node_id",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Design-time archetype identifier of this node taken from its generating archetype; used to build archetype paths. Always in the form of an at-code, e.g.  `at0005`. This value enables a 'standardised' name for this node to be generated, by referring to the generating archetype local terminology. \n\nAt an archetype root point, the value of this attribute is always the stringified form of the `_archetype_id_` found in the `_archetype_details_` object. \n"
    },
    {
      "name": "feeder_audit",
      "typeName": "FEEDER_AUDIT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Audit trail from non-openEHR system of original commit of information forming the content of this node, or from a conversion gateway which has synthesised this node. "
    },
    {
      "name": "links",
      "typeName": "List<LINK>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Links to other archetyped structures (data whose root object inherits from `ARCHETYPED`, such as `ENTRY`, `SECTION` and so on). Links may be to structures in other compositions. "
    },
    {
      "name": "name",
      "typeName": "DV_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Runtime name of this fragment, used to build runtime paths. This is the term provided via a clinical application or batch process to name this EHR construct: its retention in the EHR faithfully preserves the original label by which this entry was known to end users. \n"
    },
    {
      "name": "uid",
      "typeName": "UID_BASED_ID",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Optional globally unique object identifier for root points of archetyped structures. "
    }
  ],
  "ARCHETYPED": [
    {
      "name": "archetype_id",
      "typeName": "ARCHETYPE_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Globally unique archetype identifier. "
    },
    {
      "name": "rm_version",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Version of the openEHR reference model used to create this object. Expressed in terms of the release version string, e.g.  1.0 ,  1.2.4 ."
    },
    {
      "name": "template_id",
      "typeName": "TEMPLATE_ID",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Globally unique template identifier, if a template was active at this point in the structure. Normally, a template would only be used at the top of a top-level structure, but the possibility exists for templates at lower levels. "
    }
  ],
  "FEEDER_AUDIT": [
    {
      "name": "feeder_system_audit",
      "typeName": "FEEDER_AUDIT_DETAILS",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Any audit information for the information item from the feeder system, if different from the originating system."
    },
    {
      "name": "feeder_system_item_ids",
      "typeName": "List<DV_IDENTIFIER>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Identifiers used for the item in the feeder system, where the feeder system is distinct from the originating system. "
    },
    {
      "name": "original_content",
      "typeName": "DV_ENCAPSULATED",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Optional inline inclusion of or reference to original content corresponding to the openEHR content at this node. Typically a URI reference to a document or message in a persistent store associated with the EHR. "
    },
    {
      "name": "originating_system_audit",
      "typeName": "FEEDER_AUDIT_DETAILS",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Any audit information for the information item from the originating system. "
    },
    {
      "name": "originating_system_item_ids",
      "typeName": "List<DV_IDENTIFIER>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Identifiers used for the item in the originating system, e.g. filler and placer ids. "
    }
  ],
  "FEEDER_AUDIT_DETAILS": [
    {
      "name": "location",
      "typeName": "PARTY_IDENTIFIED",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Identifier of the particular site/facility within an organisation which handled the item. For computability, this identifier needs to be e.g. a PKI identifier which can be included in the identifier list of the `PARTY_IDENTIFIED` object. "
    },
    {
      "name": "other_details",
      "typeName": "ITEM_STRUCTURE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Optional attribute to carry any custom meta-data. May be archetyped."
    },
    {
      "name": "provider",
      "typeName": "PARTY_IDENTIFIED",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional provider(s) who created, committed, forwarded or otherwise handled the item. "
    },
    {
      "name": "subject",
      "typeName": "PARTY_PROXY",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Identifiers for subject of the received information item. "
    },
    {
      "name": "system_id",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Identifier of the system which handled the information item. This is the IT system owned by the organisation legally responsible for handling the data, and at which the data were previously created or passed by an earlier system.\n"
    },
    {
      "name": "time",
      "typeName": "DV_DATE_TIME",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Time of handling the item. For an originating system, this will be time of creation, for an intermediate feeder system, this will be a time of accession or other time of handling, where available."
    },
    {
      "name": "version_id",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Any identifier used in the system such as  \"interim\" ,  \"final\" , or numeric versions if available. "
    }
  ],
  "VERSIONED_OBJECT": [
    {
      "name": "owner_id",
      "typeName": "OBJECT_REF",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Reference to object to which this version container belongs, e.g. the id of the containing EHR or other relevant owning entity. "
    },
    {
      "name": "time_created",
      "typeName": "DV_DATE_TIME",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Time of initial creation of this versioned object. "
    },
    {
      "name": "uid",
      "typeName": "HIER_OBJECT_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Unique identifier of this version container in the form of a UID with no extension. This id will be the same in all instances of the same container in a distributed environment, meaning that it can be understood as the uid of the  virtual version tree. "
    }
  ],
  "CONTRIBUTION": [
    {
      "name": "audit",
      "typeName": "AUDIT_DETAILS",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Audit trail corresponding to the committal of this Contribution. "
    },
    {
      "name": "uid",
      "typeName": "HIER_OBJECT_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Unique identifier for this Contribution. "
    },
    {
      "name": "versions",
      "typeName": "List<OBJECT_REF>",
      "min": 1,
      "max": null,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Set of references to Versions causing changes to this EHR. Each contribution contains a list of versions, which may include paths pointing to any number of versionable items, i.e. items of types such as `COMPOSITION` and `FOLDER`. "
    }
  ],
  "VERSION": [
    {
      "name": "commit_audit",
      "typeName": "AUDIT_DETAILS",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Audit trail corresponding to the committal of this version to the `VERSIONED_OBJECT`."
    },
    {
      "name": "contribution",
      "typeName": "OBJECT_REF",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Contribution in which this version was added. "
    },
    {
      "name": "signature",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "OpenPGP digital signature or digest of content committed in this Version. "
    }
  ],
  "IMPORTED_VERSION": [
    {
      "name": "item",
      "typeName": "ORIGINAL_VERSION",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The `ORIGINAL_VERSION` object that was imported. "
    }
  ],
  "ORIGINAL_VERSION": [
    {
      "name": "attestations",
      "typeName": "List<ATTESTATION>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Set of attestations relating to this version. "
    },
    {
      "name": "data",
      "typeName": "T",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Data content of this Version."
    },
    {
      "name": "lifecycle_state",
      "typeName": "DV_CODED_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Lifecycle state of the content item in this version; coded by openEHR vocabulary `version lifecycle state`."
    },
    {
      "name": "other_input_version_uids",
      "typeName": "List<OBJECT_VERSION_ID>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Identifiers of other versions whose content was merged into this version, if any. "
    },
    {
      "name": "preceding_version_uid",
      "typeName": "OBJECT_VERSION_ID",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Stored version of inheritance precursor. "
    },
    {
      "name": "uid",
      "typeName": "OBJECT_VERSION_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Stored version of inheritance precursor. "
    }
  ],
  "REVISION_HISTORY_ITEM": [
    {
      "name": "audits",
      "typeName": "List<AUDIT_DETAILS>",
      "min": 1,
      "max": null,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The audits for this revision; there will always be at least one commit audit (which may itself be an `ATTESTATION`), there may also be further attestations. "
    },
    {
      "name": "version_id",
      "typeName": "OBJECT_VERSION_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Version identifier for this revision. "
    }
  ],
  "AUDIT_DETAILS": [
    {
      "name": "change_type",
      "typeName": "DV_CODED_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Type of change. Coded using the openEHR Terminology  audit change type  group."
    },
    {
      "name": "committer",
      "typeName": "PARTY_PROXY",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Identity and optional reference into identity management service, of user who committed the item. "
    },
    {
      "name": "description",
      "typeName": "DV_TEXT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Reason for committal. This may be used to qualify the value in the `_change_type_` field. For example, if the change affects only the EHR directory, this field might be used to indicate 'Folder \"episode 2018-02-16\" added' or similar."
    },
    {
      "name": "system_id",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Identifier of the logical EHR system where the change was committed. This is almost always owned by the organisation legally responsible for the EHR, and is distinct from any application, or any hosting infrastructure."
    },
    {
      "name": "time_committed",
      "typeName": "DV_DATE_TIME",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Time of committal of the item. "
    }
  ],
  "ATTESTATION": [
    {
      "name": "attested_view",
      "typeName": "DV_MULTIMEDIA",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional visual representation of content attested e.g. screen image. "
    },
    {
      "name": "is_pending",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if this attestation is outstanding; False means it has been completed."
    },
    {
      "name": "items",
      "typeName": "List<DV_EHR_URI>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Items attested, expressed as fully qualified runtime paths to the items in question. Although not recommended, these may include fine-grained items which have been attested in some other system. Otherwise it is assumed to be for the entire VERSION with which it is associated. "
    },
    {
      "name": "proof",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Proof of attestation. "
    },
    {
      "name": "reason",
      "typeName": "DV_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Reason of this attestation. Optionally coded by the openEHR Terminology group  attestation reason ; includes values like  authorisation ,  witness  etc. "
    }
  ],
  "PARTICIPATION": [
    {
      "name": "function",
      "typeName": "DV_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The function of the Party in this participation (note that a given party might participate in more than one way in a particular activity). This attribute should be coded, but cannot be limited to the HL7v3:ParticipationFunction vocabulary, since it is too limited and hospital-oriented. "
    },
    {
      "name": "mode",
      "typeName": "DV_CODED_TEXT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional field for recording the 'mode' of the performer / activity interaction, e.g. present, by telephone, by email etc. "
    },
    {
      "name": "performer",
      "typeName": "PARTY_PROXY",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "The id and possibly demographic system link of the party participating in the activity. "
    },
    {
      "name": "time",
      "typeName": "DV_INTERVAL<DV_DATE_TIME>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The time interval during which the participation took place, if it is used in an observational context (i.e. recording facts about the past); or the intended time interval of the participation when used in future contexts, such as EHR Instructions. "
    }
  ],
  "PARTY_PROXY": [
    {
      "name": "external_ref",
      "typeName": "PARTY_REF",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional reference to more detailed demographic or identification information for this party, in an external system. "
    }
  ],
  "PARTY_IDENTIFIED": [
    {
      "name": "identifiers",
      "typeName": "List<DV_IDENTIFIER>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "One or more formal identifiers (possibly computable). \n"
    },
    {
      "name": "name",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional human-readable name (in String form)."
    }
  ],
  "PARTY_RELATED": [
    {
      "name": "relationship",
      "typeName": "DV_CODED_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Relationship of subject of this ENTRY to the subject of the record. May be coded. If it is the patient, coded as  self. "
    }
  ],
  "REVISION_HISTORY": [
    {
      "name": "items",
      "typeName": "List<REVISION_HISTORY_ITEM>",
      "min": 1,
      "max": null,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The items in this history in most-recent-last order. "
    }
  ],
  "FOLDER": [
    {
      "name": "details",
      "typeName": "ITEM_STRUCTURE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Archetypable meta-data for `FOLDER`."
    },
    {
      "name": "folders",
      "typeName": "List<FOLDER>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Sub-folders of this `FOLDER`. "
    },
    {
      "name": "items",
      "typeName": "List<OBJECT_REF>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The list of references to other (usually) versioned objects logically in this folder. "
    }
  ],
  "ITEM_TAG": [
    {
      "name": "key",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The tag key. May not be empty or contain leading or trailing whitespace."
    },
    {
      "name": "owner_id",
      "typeName": "OBJECT_REF",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Identifier of owner object, such as EHR."
    },
    {
      "name": "target",
      "typeName": "UID_BASED_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Identifier of target, which may be a `VERSIONED_OBJECT<T>` or a `VERSION<T>`."
    },
    {
      "name": "target_path",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional archetype (i.e. AQL) or RM path within `_target_`, used to tag a fine-grained element."
    },
    {
      "name": "value",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The value. If set, may not be empty."
    }
  ],
  "ITEM_TREE": [
    {
      "name": "items",
      "typeName": "List<ITEM>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "The items comprising the `ITEM_TREE`. Can include 0 or more `CLUSTERs` and/or 0 or more individual `ELEMENTs`."
    }
  ],
  "ITEM_SINGLE": [
    {
      "name": "item",
      "typeName": "ELEMENT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false
    }
  ],
  "ITEM_TABLE": [
    {
      "name": "rows",
      "typeName": "List<CLUSTER>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Physical representation of the table as a list of `CLUSTERs`, each containing the data of one row of the table. "
    }
  ],
  "ITEM_LIST": [
    {
      "name": "items",
      "typeName": "List<ELEMENT>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Physical representation of the list. "
    }
  ],
  "EVENT": [
    {
      "name": "data",
      "typeName": "T",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The data of this event."
    },
    {
      "name": "state",
      "typeName": "ITEM_STRUCTURE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Optional state data for this event."
    },
    {
      "name": "time",
      "typeName": "DV_DATE_TIME",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Time of this event. If the width is non-zero, it is the time point of the trailing edge of the event. "
    }
  ],
  "INTERVAL_EVENT": [
    {
      "name": "math_function",
      "typeName": "DV_CODED_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Mathematical function of the data of this event, e.g.  maximum, mean etc. Coded using https://github.com/openEHR/terminology/blob/master/openEHR_RM/en/openehr_terminology.xml[openEHR vocabulary `event math function`]. Default value `640|actual|`, meaning 'actual value'."
    },
    {
      "name": "sample_count",
      "typeName": "Integer",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional count of original samples to which this event corresponds."
    },
    {
      "name": "width",
      "typeName": "DV_DURATION",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Duration of the time interval during which the values recorded under `data` are true and, if set, the values recorded under `state` are true. Void if an instantaneous event."
    }
  ],
  "HISTORY": [
    {
      "name": "duration",
      "typeName": "DV_DURATION",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Duration of the entire History; either corresponds to the duration of all the events, and/or the duration represented by the summary, if it exists. "
    },
    {
      "name": "events",
      "typeName": "List<EVENT<T>>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "The events in the series. This attribute is of a generic type whose parameter must be a descendant of `ITEM_SUTRUCTURE`."
    },
    {
      "name": "origin",
      "typeName": "DV_DATE_TIME",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Time origin of this event history. The first event is not necessarily at the origin point. "
    },
    {
      "name": "period",
      "typeName": "DV_DURATION",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Period between samples in this segment if periodic."
    },
    {
      "name": "summary",
      "typeName": "ITEM_STRUCTURE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Optional summary data that aggregates, organizes, reduces and transforms the event series. This may be a text or image that presents a graphical presentation, or some data that assists with the interpretation of the data."
    }
  ],
  "CLUSTER": [
    {
      "name": "items",
      "typeName": "List<ITEM>",
      "min": 1,
      "max": null,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Ordered list of items - `CLUSTER` or `ELEMENT` objects - under this `CLUSTER`. "
    }
  ],
  "ELEMENT": [
    {
      "name": "null_flavour",
      "typeName": "DV_CODED_TEXT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Flavour of null value, e.g. `253|unknown|`, `271|no information|`, `272|masked|`, and `273|not applicable|`."
    },
    {
      "name": "null_reason",
      "typeName": "DV_TEXT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional specific reason for null value; if set, `_null_flavour_` must be set. Null reason may apply only to a minority of clinical data, commonly needed in reporting contexts."
    },
    {
      "name": "value",
      "typeName": "DATA_VALUE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Property representing leaf value object of `ELEMENT`. In real data, any concrete subtype of `DATA_VALUE` can be used."
    }
  ],
  "DV_BOOLEAN": [
    {
      "name": "value",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Boolean value of this item. Actual values may be language or implementation dependent."
    }
  ],
  "DV_STATE": [
    {
      "name": "is_terminal",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Indicates whether this state is a terminal state, such as  \"aborted\",  \"completed\" etc. from which no further transitions are possible."
    },
    {
      "name": "value",
      "typeName": "DV_CODED_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The state name. State names are determined by a state/event table defined in archetypes, and coded using openEHR Terminology or local archetype terms, as specified by the archetype. "
    }
  ],
  "DV_IDENTIFIER": [
    {
      "name": "assigner",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional organisation that assigned the id to the item being identified."
    },
    {
      "name": "id",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The identifier value. Often structured, according to the definition of the issuing authority's rules. "
    },
    {
      "name": "issuer",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional authority which issues the kind of id used in the id field of this object. "
    },
    {
      "name": "type",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional identifier type, such as  prescription , or  Social Security Number . One day a controlled vocabulary might be possible for this."
    }
  ],
  "DV_ENCAPSULATED": [
    {
      "name": "charset",
      "typeName": "CODE_PHRASE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Name of character encoding scheme in which this value is encoded. Coded from openEHR Code Set  character sets . Unicode is the default assumption in openEHR, with UTF-8 being the assumed encoding. This attribute allows for variations from these assumptions. "
    },
    {
      "name": "language",
      "typeName": "CODE_PHRASE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional indicator of the localised language in which the data is written, if relevant. Coded from openEHR Code Set `languages`."
    }
  ],
  "DV_MULTIMEDIA": [
    {
      "name": "alternate_text",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Text to display in lieu of multimedia display/replay."
    },
    {
      "name": "compression_algorithm",
      "typeName": "CODE_PHRASE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Compression type, a coded value from the openEHR Integrity check code set. Void means no compression. "
    },
    {
      "name": "data",
      "typeName": "Array<Octet>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The actual data found at `_uri_`, if supplied inline."
    },
    {
      "name": "integrity_check",
      "typeName": "Array<Octet>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Binary cryptographic integrity checksum."
    },
    {
      "name": "integrity_check_algorithm",
      "typeName": "CODE_PHRASE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Type of integrity check, a coded value from the openEHR `Integrity check` code set. "
    },
    {
      "name": "media_type",
      "typeName": "CODE_PHRASE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Data media type coded from openEHR code set  media types  (interface for the IANA MIME types code set). \n"
    },
    {
      "name": "size",
      "typeName": "Integer",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Original size in bytes of unencoded encapsulated data. I.e. encodings such as base64, hexadecimal etc do not change the value of this attribute."
    },
    {
      "name": "thumbnail",
      "typeName": "DV_MULTIMEDIA",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The thumbnail for this item, if one exists; mainly for graphics formats."
    },
    {
      "name": "uri",
      "typeName": "DV_URI",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "URI reference to electronic information stored outside the record as a file, database entry etc, if supplied as a reference. \n"
    }
  ],
  "DV_PARSABLE": [
    {
      "name": "formalism",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Name of the formalism, e.g.  GLIF 1.0 ,  Proforma  etc."
    },
    {
      "name": "value",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The string, which may validly be empty in some syntaxes."
    }
  ],
  "DV_PARAGRAPH": [
    {
      "name": "items",
      "typeName": "List<DV_TEXT>",
      "min": 1,
      "max": null,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Items making up the paragraph, each of which is a text item (which may have its own formatting, and/or have hyperlinks). "
    }
  ],
  "DV_TEXT": [
    {
      "name": "encoding",
      "typeName": "CODE_PHRASE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Name of character encoding scheme in which this value is encoded. Coded from openEHR Code Set  character sets . Unicode is the default assumption in openEHR, with UTF-8 being the assumed encoding. This attribute allows for variations from these assumptions. \n"
    },
    {
      "name": "formatting",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "If set, contains one of the following values:\n\n* `\"plain\"`: use for plain text, possibly containing newlines, but otherwise unformatted (same as Void);\n* `\"plain_no_newlines\"`: use for text containing no newlines or other formatting;\n* `\"markdown\"`: use for markdown formatted text, strongly recommended in the format of the CommonMark specification.\n\nDEPRECATED usage: contains a string of the form `\"name:value; name:value...\"` , e.g. `\"font-weight : bold; font-family : Arial; font-size : 12pt;\"`. Values taken from W3C CSS2 properties lists for background and font . "
    },
    {
      "name": "hyperlink",
      "typeName": "DV_URI",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "DEPRECATED: this field is deprecated; use markdown link/text in the `_value_` attribute, and `\"markdown\"` as the value of the `_formatting_` field.\n\nOriginal usage, prior to RM Release 1.0.4: Optional link sitting behind a section of plain text or coded term item."
    },
    {
      "name": "language",
      "typeName": "CODE_PHRASE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional indicator of the localised language in which the value is written. Coded from openEHR Code Set  languages . Only used when either the text object is in a different language from the enclosing `ENTRY`, or else the text object is being used outside of an `ENTRY` or other enclosing structure which indicates the language. "
    },
    {
      "name": "mappings",
      "typeName": "List<TERM_MAPPING>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Terms from other terminologies most closely matching this term, typically used where the originator (e.g. pathology lab) of information uses a local terminology but also supplies one or more equivalents from well known terminologies (e.g. LOINC). \n"
    },
    {
      "name": "value",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Displayable rendition of the item, regardless of its underlying structure. For `DV_CODED_TEXT`, this is the rubric of the complete term as provided by the terminology service.\n"
    }
  ],
  "DV_CODED_TEXT": [
    {
      "name": "defining_code",
      "typeName": "CODE_PHRASE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The term of which the  `_value_` attribute is the textual rendition (i.e. rubric). \n"
    }
  ],
  "TERM_MAPPING": [
    {
      "name": "match",
      "typeName": "Character",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The relative match of the target term with respect to the mapped text item. Result meanings: \n\n* `'>'`: the mapping is to a broader term e.g. orginal text =  arbovirus infection , target =  viral infection  \n* `'='`: the mapping is to a (supposedly) equivalent to the original item \n* `'<'`: the mapping is to a narrower term. e.g. original text =  diabetes , mapping =  diabetes mellitus . \n* `'?'`: the kind of mapping is unknown. \n\nThe first three values are taken from the ISO standards 2788 ( Guide to Establishment and development of monolingual thesauri) and 5964 (Guide to Establishment and development of multilingual thesauri). \n"
    },
    {
      "name": "purpose",
      "typeName": "DV_CODED_TEXT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Purpose of the mapping e.g. 'automated data mining', 'billing', 'interoperability'."
    },
    {
      "name": "target",
      "typeName": "CODE_PHRASE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The target term of the mapping. "
    }
  ],
  "DV_ORDERED": [
    {
      "name": "normal_range",
      "typeName": "DV_INTERVAL",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional normal range. "
    },
    {
      "name": "normal_status",
      "typeName": "CODE_PHRASE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional normal status indicator of value with respect to normal range for this value. Often included by lab, even if the normal range itself is not included. Coded by ordinals in series HHH, HH, H, (nothing), L, LL, LLL; see openEHR terminology group  `normal_status`. "
    },
    {
      "name": "other_reference_ranges",
      "typeName": "List<REFERENCE_RANGE<DV_ORDERED>>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional tagged other reference ranges for this value in its particular measurement context."
    }
  ],
  "REFERENCE_RANGE": [
    {
      "name": "meaning",
      "typeName": "DV_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Term whose value indicates the meaning of this range, e.g.  normal,  critical,  therapeutic  etc."
    },
    {
      "name": "range",
      "typeName": "DV_INTERVAL",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The data range for this meaning, e.g. critical  etc."
    }
  ],
  "DV_QUANTIFIED": [
    {
      "name": "accuracy",
      "typeName": "Any",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Accuracy of measurement. Exact form of expression determined in descendants."
    },
    {
      "name": "magnitude_status",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional status of magnitude with values: \n\n* `\"=\"`   :   magnitude is a point value \n* `\"<\"`   :   value is < magnitude \n* `\">\"`   :   value is > magnitude \n* `\"<=\"` : value is <= magnitude \n* `\">=\"` : value is >= magnitude \n* `\"~\"`   :   value is approximately magnitude \n\nIf not present, assumed meaning is  `\"=\"` . \n"
    }
  ],
  "DV_PROPORTION": [
    {
      "name": "denominator",
      "typeName": "Real",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Denominator of ratio."
    },
    {
      "name": "normal_range",
      "typeName": "DV_INTERVAL<DV_PROPORTION>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional normal range. "
    },
    {
      "name": "numerator",
      "typeName": "Real",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Numerator of ratio"
    },
    {
      "name": "other_reference_ranges",
      "typeName": "List<REFERENCE_RANGE<DV_PROPORTION>>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional tagged other reference ranges for this value in its particular measurement context."
    },
    {
      "name": "precision",
      "typeName": "Integer",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Precision  to  which  the  `_numerator_` and `_denominator_` values of  the  proportion are expressed, in terms of number  of decimal places. The value 0 implies an integral quantity. The value -1 implies no limit, i.e. any number of decimal places. "
    },
    {
      "name": "type",
      "typeName": "Integer",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Indicates semantic type of proportion, including percent, unitary etc."
    }
  ],
  "DV_AMOUNT": [
    {
      "name": "accuracy",
      "typeName": "Real",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Accuracy of measurement, expressed either as a half-range percent value (`_accuracy_is_percent_` = `True`) or a half-range quantity. A value of `0` means that accuracy is 100%, i.e. no error.\n\nA value of `_unknown_accuracy_value_` means that accuracy was not recorded."
    },
    {
      "name": "accuracy_is_percent",
      "typeName": "Boolean",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "If `True`, indicates that when this object was created, `_accuracy_` was recorded as a percent value; if `False`, as an absolute quantity value."
    }
  ],
  "DV_QUANTITY": [
    {
      "name": "magnitude",
      "typeName": "Real",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Numeric magnitude of the quantity."
    },
    {
      "name": "normal_range",
      "typeName": "DV_INTERVAL<DV_QUANTITY>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional normal range. "
    },
    {
      "name": "other_reference_ranges",
      "typeName": "List<REFERENCE_RANGE<DV_QUANTITY>>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional tagged other reference ranges for this value in its particular measurement context."
    },
    {
      "name": "precision",
      "typeName": "Integer",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Precision to which the value of the quantity is expressed, in terms of number of decimal places. The value 0 implies an integral quantity.\nThe value -1 implies no limit, i.e. any number of decimal places."
    },
    {
      "name": "units",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Quantity units, expressed as a code or syntax string from either UCUM (the default) or the units system specified in `_units_system_`, when set.\n\nIn either case, the value is the code or syntax - normally formed of standard ASCII - which is in principal not the same as the display string, although in simple cases such as 'm' (for meters) it will be.\n\nIf the `_units_display_name_` field is set, this may be used for display. If not, the implementations must effect the resolution of the `_units_` value to a display form locally, e.g. by lookup of reference tables, request to a terminology service etc.\n\nExample values from UCUM: \"kg/m^2\", “mm[Hg]\", \"ms-1\", \"km/h\"."
    },
    {
      "name": "units_display_name",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional field containing the displayable form of the `_units_` field, e.g. `'°C'`.\n\nIf not set, the application environment needs to determine the displayable form.\n\nNOTE: The display name may be language-dependent for various older and non-systematic units. For this reason, it is not recommended to add unit display names to archetypes, only to templates (for localisation purposes)."
    },
    {
      "name": "units_system",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional field used to specify a units system from which codes in `_units_` are defined. Value is a URI identifying a terminology containing units concepts from the  (https://www.hl7.org/fhir/terminologies-systems.html[HL7 FHIR terminologies list]).\n\nIf not set, the UCUM standard (case-sensitive codes) is assumed as the units system."
    }
  ],
  "DV_COUNT": [
    {
      "name": "magnitude",
      "typeName": "Integer64",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false
    },
    {
      "name": "normal_range",
      "typeName": "DV_INTERVAL<DV_COUNT>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional normal range. "
    },
    {
      "name": "other_reference_ranges",
      "typeName": "List<REFERENCE_RANGE<DV_COUNT>>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional tagged other reference ranges for this value in its particular measurement context."
    }
  ],
  "DV_ABSOLUTE_QUANTITY": [
    {
      "name": "accuracy",
      "typeName": "DV_AMOUNT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true
    }
  ],
  "DV_ORDINAL": [
    {
      "name": "symbol",
      "typeName": "DV_CODED_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Coded textual representation of this value in the enumeration, which may be strings made from  +  symbols, or other enumerations of terms such as  `mild`, `moderate`, `severe`, or even the same number series as the values, e.g. 1, 2, 3."
    },
    {
      "name": "value",
      "typeName": "Integer",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Value in ordered enumeration of values. Any integer value can be used. \n"
    }
  ],
  "DV_SCALE": [
    {
      "name": "symbol",
      "typeName": "DV_CODED_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Coded textual representation of this value in the scale range, which may be strings made from symbols or other enumerations of terms such as  `no breathlessness`, `very very slight`, `slight breathlessness`. Codes come from archetypes.\n\nIn some cases, a scale may include values that have no code/symbol. In this case, the symbol will be a `DV-CODED_TEXT` including the `_terminology_id_` and a blank String value for `_code_string_`."
    },
    {
      "name": "value",
      "typeName": "Real",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Real number value of Scale item.\n"
    }
  ],
  "DV_DURATION": [
    {
      "name": "value",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "ISO8601 duration string, including described deviations to support negative values and weeks."
    }
  ],
  "DV_TEMPORAL": [
    {
      "name": "accuracy",
      "typeName": "DV_DURATION",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Time accuracy, expressed as a duration."
    }
  ],
  "DV_DATE": [
    {
      "name": "value",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "ISO8601 date string."
    }
  ],
  "DV_TIME": [
    {
      "name": "value",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "ISO8601 time string"
    }
  ],
  "DV_DATE_TIME": [
    {
      "name": "value",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "ISO8601 date/time string."
    }
  ],
  "DV_TIME_SPECIFICATION": [
    {
      "name": "value",
      "typeName": "DV_PARSABLE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The specification, in the HL7v3 syntax for `PIVL` or `EIVL` types."
    }
  ],
  "DV_URI": [
    {
      "name": "value",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Value of URI as a String. 'Plain-text' URIs are allowed, enabling better readability, but must be RFC-3986 encoded in use."
    }
  ],
  "EHR": [
    {
      "name": "compositions",
      "typeName": "List<OBJECT_REF>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Master list of all Versioned Composition references in this EHR."
    },
    {
      "name": "contributions",
      "typeName": "List<OBJECT_REF>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "List of contributions causing changes to this EHR. Each contribution contains a list of versions, which may include references to any number of `VERSION` instances, i.e. items of type `VERSIONED_COMPOSITION` and `VERSIONED_FOLDER`. "
    },
    {
      "name": "directory",
      "typeName": "OBJECT_REF",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional directory structure for this EHR. If present, this is a reference to the first member of `_folders_`."
    },
    {
      "name": "ehr_access",
      "typeName": "OBJECT_REF",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Reference to `EHR_ACCESS` object for this EHR."
    },
    {
      "name": "ehr_id",
      "typeName": "HIER_OBJECT_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The unique identifier of this EHR.\n\nNOTE: is is strongly recommended that a UUID always be used for this field."
    },
    {
      "name": "ehr_status",
      "typeName": "OBJECT_REF",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Reference to `EHR_STATUS` object for this EHR."
    },
    {
      "name": "folders",
      "typeName": "List<OBJECT_REF>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional additional Folder structures for this EHR. If set, the `_directory_` attribute refers to the first member."
    },
    {
      "name": "system_id",
      "typeName": "HIER_OBJECT_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The identifier of the logical EHR management system in which this EHR was created. \n"
    },
    {
      "name": "tags",
      "typeName": "List<OBJECT_REF>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional list of tags associated with this EHR. Tag `_target_` values can only be within the same EHR."
    },
    {
      "name": "time_created",
      "typeName": "DV_DATE_TIME",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Time of creation of the EHR."
    }
  ],
  "EHR_ACCESS": [
    {
      "name": "settings",
      "typeName": "ACCESS_CONTROL_SETTINGS",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Access control settings for the EHR. Instance is a subtype of the type `ACCESS_CONTROL_SETTINGS`, allowing for the use of different access control schemes. "
    }
  ],
  "EHR_STATUS": [
    {
      "name": "is_modifiable",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if the EHR, other than the `EHR_STATUS` object, is allowed to be written to. The `EHR_STATUS` object itself can always be written to."
    },
    {
      "name": "is_queryable",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if this EHR should be included in population queries, i.e. if this EHR is considered active in the population."
    },
    {
      "name": "other_details",
      "typeName": "ITEM_STRUCTURE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Any other details of the EHR summary object, in the form of an archetyped `ITEM_STRUCTURE`."
    },
    {
      "name": "subject",
      "typeName": "PARTY_SELF",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The subject of this EHR. The `_external_ref_` attribute can be used to contain a direct reference to the subject in a demographic or identity service. Alternatively, the association between patients and their records may be done elsewhere for security reasons. "
    }
  ],
  "EXTRACT": [
    {
      "name": "chapters",
      "typeName": "List<EXTRACT_CHAPTER>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The content extracted and serialised from the source repository for this Extract."
    },
    {
      "name": "participations",
      "typeName": "List<EXTRACT_PARTICIPATION>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Participations relevant to the creation of this Extract."
    },
    {
      "name": "request_id",
      "typeName": "HIER_OBJECT_ID",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Reference to causing Request, if any."
    },
    {
      "name": "sequence_nr",
      "typeName": "Integer",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Number of this Extract response in sequence of responses to Extract request identified by `_request_id_`. If this is the sole response, or there was no request, value is 1."
    },
    {
      "name": "specification",
      "typeName": "EXTRACT_SPEC",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The specification that this Extract actually conforms to; might not be identical with the specification of the corresponding request."
    },
    {
      "name": "system_id",
      "typeName": "HIER_OBJECT_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Identifier of creating system."
    },
    {
      "name": "time_created",
      "typeName": "DV_DATE_TIME",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Creation time of this Extract"
    }
  ],
  "EXTRACT_ACTION_REQUEST": [
    {
      "name": "action",
      "typeName": "DV_CODED_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Requested action: `cancel | resend | send new`. Coded by openEHR Terminology group `'extract action type'`."
    },
    {
      "name": "request_id",
      "typeName": "OBJECT_REF",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Identifier of previous `EXTRACT_REQUEST`."
    },
    {
      "name": "uid",
      "typeName": "HIER_OBJECT_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false
    }
  ],
  "EXTRACT_CHAPTER": [
    {
      "name": "items",
      "typeName": "List<EXTRACT_ITEM>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "The information content of this chapter."
    }
  ],
  "EXTRACT_CONTENT_ITEM": [
    {
      "name": "is_changed",
      "typeName": "Boolean",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "True if the content item carried in this container is any kind of change since last send, in repeat sending situations."
    },
    {
      "name": "is_masked",
      "typeName": "Boolean",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "True if the content of this item has not been included due to insufficient access rights of requestor."
    },
    {
      "name": "is_primary",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if the content item carried in this container was part of the primary set for the Extract, i.e. not added due to link-following."
    },
    {
      "name": "item",
      "typeName": "Any",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Content object."
    }
  ],
  "EXTRACT_ENTITY_CHAPTER": [
    {
      "name": "extract_id_key",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Reference to entity, usually a demographic entity such as a patient that the content of this chapter relates to."
    }
  ],
  "EXTRACT_ENTITY_MANIFEST": [
    {
      "name": "ehr_id",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "EHR / EMR identifier for the entity at the target system."
    },
    {
      "name": "extract_id_key",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Identifier by which this entity is known in the Extract. May be one of the other identifiers, e.g. ehr_id or subject_id, or it may be something else, including a simple integer."
    },
    {
      "name": "item_list",
      "typeName": "List<OBJECT_REF>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "List of Uids of items to be included in the Extract, in cases where individual items are being requested by id. More typically, this attribute is not used, and the `EXTRACT_SPEC._criteria query_` defines the Extract contents. If set, for openEHR data, these are Uids identifying the version containers."
    },
    {
      "name": "other_ids",
      "typeName": "List<String>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Other identifiers that may be used to find the entity at the target system, keyed by type. May include medicare numbers, drivers license number, tax number etc."
    },
    {
      "name": "subject_id",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Subject (i.e. patient or similar) identifier for the entity at the target system."
    }
  ],
  "EXTRACT_ERROR": [
    {
      "name": "reason",
      "typeName": "DV_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false
    },
    {
      "name": "request_id",
      "typeName": "OBJECT_REF",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false
    }
  ],
  "EXTRACT_FOLDER": [
    {
      "name": "items",
      "typeName": "List<EXTRACT_ITEM>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "List of Folders and content items in this Folder."
    }
  ],
  "EXTRACT_MANIFEST": [
    {
      "name": "entities",
      "typeName": "List<EXTRACT_ENTITY_MANIFEST>",
      "min": 1,
      "max": null,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "List of entity manifests uids of items included in the Extract; for openEHR data, these are uids identifying the version containers."
    }
  ],
  "EXTRACT_PARTICIPATION": [
    {
      "name": "function",
      "typeName": "DV_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The function of the Party in this participation (note that a given party might participate in more than one way in a particular activity). This attribute should be coded, but cannot be limited to the HL7v3:ParticipationFunction vocabulary, since it is too limited and hospital-oriented. "
    },
    {
      "name": "mode",
      "typeName": "DV_CODED_TEXT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The mode of the performer / activity interaction, e.g. present, by telephone, by email etc. "
    },
    {
      "name": "performer",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Uid of demographic entity within Extract who performed this participation."
    },
    {
      "name": "time",
      "typeName": "DV_INTERVAL<DV_DATE_TIME>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The time interval during which the participation took place, if it is used in an observational context (i.e. recording facts about the past); or the intended time interval of the participation when used in future contexts, such as EHR Instructions. "
    }
  ],
  "EXTRACT_REQUEST": [
    {
      "name": "extract_spec",
      "typeName": "EXTRACT_SPEC",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Specification details of the request."
    },
    {
      "name": "uid",
      "typeName": "HIER_OBJECT_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Identifier of this Request, generated by requestor."
    },
    {
      "name": "update_spec",
      "typeName": "EXTRACT_UPDATE_SPEC",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Update details of the request."
    }
  ],
  "EXTRACT_SPEC": [
    {
      "name": "criteria",
      "typeName": "List<DV_PARSABLE>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Queries specifying the contents of this Extract."
    },
    {
      "name": "extract_type",
      "typeName": "DV_CODED_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Coded term indicating the type of content required, e.g.\n\n* `|openehr-ehr|`\n* `|openehr-demographic|`\n* `|generic-emr|`\n* `|other|`\n\nCoded by openEHR Terminology group `'extract content type'`."
    },
    {
      "name": "include_multimedia",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Indicates whether in-line instances of `DV_MULTIMEDIA` in the source data are included or not."
    },
    {
      "name": "link_depth",
      "typeName": "Integer",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Degree of links to follow emanating from content items specified for inclusion. The kind of links to follow is dependent on the type of Extract.\n\nAll items at the target end of followed links at the given depth are also included in the extract; `EXTRACT_CONTENT_ITEM._is_primary_` is used to differentiate.\n\n* 0 = don't follow;\n* 1 = follow first degree links;\n* 2 = follow 2nd degree links;\n* ....\n* n = follow nth degree links\n"
    },
    {
      "name": "manifest",
      "typeName": "EXTRACT_MANIFEST",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Specification of entities (e.g. records) to include in the Extract."
    },
    {
      "name": "other_details",
      "typeName": "ITEM_STRUCTURE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Other specification items. Archetypable."
    },
    {
      "name": "priority",
      "typeName": "Integer",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Requested priority of this request to be handled by server. Priority schemes are likely to be local, and use values agreed by both ends.\n\nTBD: alternative is standard coded terms"
    },
    {
      "name": "version_spec",
      "typeName": "EXTRACT_VERSION_SPEC",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Specification of which versions of information items to include in the Extract. If Void, the default is latest versions only (which is reasonable for non-versioning systems as well)."
    }
  ],
  "EXTRACT_UPDATE_SPEC": [
    {
      "name": "persist_in_server",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "If True, this Request is persisted in the server until further notice."
    },
    {
      "name": "repeat_period",
      "typeName": "DV_DURATION",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Period for resending update Extracts in response to original Request."
    },
    {
      "name": "trigger_events",
      "typeName": "List<DV_CODED_TEXT>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Set of Event names that will cause sending of update Extracts. Event types include:   \n\n* `|any_change|` - any change in content items matched by content specification, e.g. new versions of persistent compositions. If the content list allows matching of any, or a wide range of archetypes, this event type will match any additions to the record.\n* `|correction|` - match error corrections only, including deletions.\n* `|update|` - match updates (i.e. new versions) of included content items.\n\nCoded by openEHR Terminology group 'extract update trigger event type'."
    },
    {
      "name": "update_method",
      "typeName": "CODE_PHRASE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Indicate mode of update. Can be: send only items that are changed (including logical deletions) or new since last send. For `_persist_in_server_` Requests only."
    }
  ],
  "EXTRACT_VERSION_SPEC": [
    {
      "name": "commit_time_interval",
      "typeName": "DV_INTERVAL<DV_DATE_TIME>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Specifies commit time interval of items to source repository to include in Extract. By default, only latest versions whose commit times fall in the range are included. If include_all_versions is True, then the range includes all versions committed within the interval."
    },
    {
      "name": "include_all_versions",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if all versions of each item in the Extract are included."
    },
    {
      "name": "include_data",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "`True` if the data of items matched by the content spec should be included. This is the default. If `False`, only revision history is included in serialised versions. Turning this option on in openEHR systems causes `X_VERSIONED_OBJECTs` to have `_revision_history_` set, but versions Void. Useful for interrogating a server without having to look at any content data. In other systems it may or may not have a sensible meaning."
    },
    {
      "name": "include_revision_history",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if revision histories of the items in the Extract are included. If included, it is always the full revision history."
    }
  ],
  "OPENEHR_CONTENT_ITEM": [
    {
      "name": "item",
      "typeName": "X_VERSIONED_OBJECT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Content object."
    }
  ],
  "X_VERSIONED_OBJECT": [
    {
      "name": "extract_version_count",
      "typeName": "Integer",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The number of Versions in this extract for this Versioned object, i.e. the count of items in the versions attribute. May be 0 if only revision history is requested."
    },
    {
      "name": "owner_id",
      "typeName": "OBJECT_REF",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Owner_id from original `VERSIONED_OBJECT`, which identifies source EHR."
    },
    {
      "name": "revision_history",
      "typeName": "REVISION_HISTORY",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional revision history of the original `VERSIONED_OBJECT`. If included, it is the complete revision history."
    },
    {
      "name": "time_created",
      "typeName": "DV_DATE_TIME",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Creation time of original `VERSIONED_OBJECT`."
    },
    {
      "name": "total_version_count",
      "typeName": "Integer",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Total number of versions in original `VERSIONED_OBJECT` at time of creation of this `X_VERSIONED_OBJECT`."
    },
    {
      "name": "uid",
      "typeName": "HIER_OBJECT_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Uid of original `VERSIONED_OBJECT`."
    },
    {
      "name": "versions",
      "typeName": "List<ORIGINAL_VERSION<T>>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "0 or more Versions from the original `VERSIONED_OBJECT`, according to the Extract specification."
    }
  ],
  "GENERIC_CONTENT_ITEM": [
    {
      "name": "author",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Reference to a demographic entity elsewhere in this Extract representing the author of the item version. The reference should be a UID corresponding to the UID of a `GENERIC_CONTENT_ITEM` containing the demographic information."
    },
    {
      "name": "authorisation_time",
      "typeName": "Iso8601_date_time",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Time of authorisation of this item version on the original system where relevant."
    },
    {
      "name": "authoriser",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Reference to a demographic entity elsewhere in this Extract representing an authoriser of the item version, if relevant. The reference should be a UID corresponding to the UID of a `GENERIC_CONTENT_ITEM` containing the demographic information."
    },
    {
      "name": "creation_time",
      "typeName": "Iso8601_date_time",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Time of creation of this item version on the original system. This may be an earlier commit time, or it may be the time at which the item was created during the Extract generation process."
    },
    {
      "name": "item",
      "typeName": "LOCATABLE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Content object."
    },
    {
      "name": "item_status",
      "typeName": "DV_CODED_TEXT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Coded lifecycle status of the item."
    },
    {
      "name": "item_type",
      "typeName": "DV_CODED_TEXT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Identifier of model or schema used to create the content."
    },
    {
      "name": "item_type_version",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Version of model or schema used to create the content item."
    },
    {
      "name": "other_details",
      "typeName": "Hash<String, String>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Other details about the content item."
    },
    {
      "name": "system_id",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Identifier of EMR or other system from which the item was created / extracted. Typically in the form of a domain name."
    },
    {
      "name": "version_id",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Version id of this item in original system."
    },
    {
      "name": "version_set_id",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Version set id of this item in original system, where applicable."
    }
  ],
  "SYNC_EXTRACT_REQUEST": [
    {
      "name": "specification",
      "typeName": "SYNC_EXTRACT_SPEC",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Details of specification of synchronisation request."
    }
  ],
  "SYNC_EXTRACT": [
    {
      "name": "items",
      "typeName": "List<X_CONTRIBUTION>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Content, in the form of a serialised Contributions."
    },
    {
      "name": "specification",
      "typeName": "SYNC_EXTRACT_SPEC",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Details of specification of this Extract."
    }
  ],
  "X_CONTRIBUTION": [
    {
      "name": "audit",
      "typeName": "AUDIT_DETAILS",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Audit of Contribution in source system."
    },
    {
      "name": "uid",
      "typeName": "HIER_OBJECT_ID",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Uid of Contribution in source system."
    },
    {
      "name": "versions",
      "typeName": "List<VERSION<X_CONTRIBUTION>>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Serialised Versions from Contribution in source system."
    }
  ],
  "SYNC_EXTRACT_SPEC": [
    {
      "name": "all_contributions",
      "typeName": "Boolean",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "True if all Contributions in the record are included."
    },
    {
      "name": "contribution_list",
      "typeName": "List<HIER_OBJECT_ID>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "List of Contributions to include / that are included in the Extract."
    },
    {
      "name": "contributions_since",
      "typeName": "DV_DATE_TIME",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Specify Contributions included in Extract by threshold date."
    },
    {
      "name": "includes_versions",
      "typeName": "Boolean",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "True if the Versions from the Contribution are included; False if just the Contribution and its Audit are included."
    }
  ],
  "MESSAGE": [
    {
      "name": "audit",
      "typeName": "AUDIT_DETAILS",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Details of who actually created the message and when. This is the person who entered the data or otherwise caused the message to be created, or might be a piece of software."
    },
    {
      "name": "author",
      "typeName": "PARTY_PROXY",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Party responsible for the message content, who may or may not be technically responsible for its creation (e.g. by data entry etc)."
    },
    {
      "name": "content",
      "typeName": "MESSAGE_CONTENT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Content of the message."
    },
    {
      "name": "signature",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional signature by the author of message content in openPGP format. The signature is created as a Hash and optional signing of the serialisation of this message object with this signature field Void."
    }
  ],
  "ADDRESSED_MESSAGE": [
    {
      "name": "addressees",
      "typeName": "List<String>",
      "min": 1,
      "max": null,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Intended recipients, in the form of internet addresses."
    },
    {
      "name": "message",
      "typeName": "MESSAGE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The content of the message."
    },
    {
      "name": "sender",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Party sending the message."
    },
    {
      "name": "sender_reference",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Identification of message used by sender. This will be the same no matter how many times this message is sent to these recipients."
    },
    {
      "name": "urgency",
      "typeName": "Integer",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Urgency with which destination should deal with message:\n\n* -1 - low\n* 0 - normal\n* 1 - high"
    }
  ],
  "PARTY": [
    {
      "name": "contacts",
      "typeName": "List<CONTACT>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Contacts for this party."
    },
    {
      "name": "details",
      "typeName": "ITEM_STRUCTURE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "All other details for this Party."
    },
    {
      "name": "identities",
      "typeName": "List<PARTY_IDENTITY>",
      "min": 1,
      "max": null,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Identities used by the party to identify itself, such as legal name, stage names, aliases, nicknames and so on."
    },
    {
      "name": "relationships",
      "typeName": "List<PARTY_RELATIONSHIP>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Relationships in which this Party takes part as source."
    }
  ],
  "CONTACT": [
    {
      "name": "addresses",
      "typeName": "List<ADDRESS>",
      "min": 1,
      "max": null,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "A set of address alternatives for this contact purpose and time validity combination."
    },
    {
      "name": "time_validity",
      "typeName": "DV_INTERVAL<DV_DATE>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Valid time interval for this contact descriptor."
    }
  ],
  "ADDRESS": [
    {
      "name": "details",
      "typeName": "ITEM_STRUCTURE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Archetypable structured address."
    }
  ],
  "PARTY_IDENTITY": [
    {
      "name": "details",
      "typeName": "ITEM_STRUCTURE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "The value of the identity. This will often taken the form of a parseable string or a small structure of strings."
    }
  ],
  "ROLE": [
    {
      "name": "capabilities",
      "typeName": "List<CAPABILITY>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The capabilities of this role."
    },
    {
      "name": "performer",
      "typeName": "PARTY_REF",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Reference to Version container of Actor playing the role."
    },
    {
      "name": "time_validity",
      "typeName": "DV_INTERVAL<DV_DATE>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Valid time interval for this role."
    }
  ],
  "ACTOR": [
    {
      "name": "languages",
      "typeName": "List<DV_TEXT>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Languages which can be used to communicate with this actor, in preferred order of use (if known, else order irrelevant)."
    },
    {
      "name": "roles",
      "typeName": "List<PARTY_REF>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Identifiers of the Version container for each Role played by this Party."
    }
  ],
  "CAPABILITY": [
    {
      "name": "credentials",
      "typeName": "ITEM_STRUCTURE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "The qualifications of the performer of the role for this capability. This might include professional qualifications and official identifications such as provider numbers etc."
    },
    {
      "name": "time_validity",
      "typeName": "DV_INTERVAL<DV_DATE>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Valid time interval for the credentials of this capability."
    }
  ],
  "PARTY_RELATIONSHIP": [
    {
      "name": "details",
      "typeName": "ITEM_STRUCTURE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "The detailed description of the relationship."
    },
    {
      "name": "source",
      "typeName": "PARTY_REF",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Source of relationship."
    },
    {
      "name": "target",
      "typeName": "PARTY_REF",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Target of relationship."
    },
    {
      "name": "time_validity",
      "typeName": "DV_INTERVAL<DV_DATE>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Valid time interval for this relationship."
    }
  ],
  "GENERIC_ENTRY": [
    {
      "name": "data",
      "typeName": "ITEM",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "The data from the source message or record. May be recorded in any structural openEHR representation."
    }
  ],
  "COMPOSITION": [
    {
      "name": "category",
      "typeName": "DV_CODED_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Temporal category of this Composition, i.e. \n\n* `431|persistent|` - of potential life-time validity;\n* `451|episodic|` - valid over the life of a care episode;\n* `433|event|` - valid at the time of recording (long-term validity requires subsequent clinical assessment).\n\nor any other code defined in the openEHR terminology group 'category'.\n"
    },
    {
      "name": "composer",
      "typeName": "PARTY_PROXY",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "The person primarily responsible for the content of the Composition (but not necessarily its committal into the EHR system). This is the identifier which should appear on the screen. It may or may not be the person who entered the data. When it is the patient, the special self  instance of `PARTY_PROXY` will be used."
    },
    {
      "name": "content",
      "typeName": "List<CONTENT_ITEM>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "The content of this Composition. "
    },
    {
      "name": "context",
      "typeName": "EVENT_CONTEXT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The clinical session context of this Composition, i.e. the contextual attributes of the clinical session. "
    },
    {
      "name": "language",
      "typeName": "CODE_PHRASE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Mandatory indicator of the localised language in which this Composition is written. Coded from openEHR Code Set  `languages`. The language of an Entry if different from the Composition is indicated in `ENTRY._language_`. "
    },
    {
      "name": "territory",
      "typeName": "CODE_PHRASE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Name of territory in which this Composition was written. Coded from openEHR  countries  code set, which is an expression of the ISO 3166 standard."
    }
  ],
  "EVENT_CONTEXT": [
    {
      "name": "end_time",
      "typeName": "DV_DATE_TIME",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional end time of the clinical session. \n"
    },
    {
      "name": "health_care_facility",
      "typeName": "PARTY_IDENTIFIED",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The health care facility under whose care the event took place. This is the most specific workgroup or delivery unit within a care delivery enterprise that has an official identifier in the health system, and can be used to ensure medico-legal accountability. "
    },
    {
      "name": "location",
      "typeName": "String",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The actual location where the session occurred, e.g. 'microbiology lab 2', 'home', 'ward A3'  and so on."
    },
    {
      "name": "other_context",
      "typeName": "ITEM_STRUCTURE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Other optional context which will be archetyped."
    },
    {
      "name": "participations",
      "typeName": "List<PARTICIPATION>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Parties involved in the healthcare event. These would normally include the physician(s) and often the patient (but not the latter if the clinical session is a pathology test for example). "
    },
    {
      "name": "setting",
      "typeName": "DV_CODED_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The setting in which the clinical session took place. Coded using the openEHR Terminology,  setting  group. "
    },
    {
      "name": "start_time",
      "typeName": "DV_DATE_TIME",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Start time of the clinical session or other kind of event during which a provider performs a service of any kind for the patient. "
    }
  ],
  "SECTION": [
    {
      "name": "items",
      "typeName": "List<CONTENT_ITEM>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Ordered list of content items under this section, which may include:\n\n* more `SECTIONs`;\n* `ENTRYs`."
    }
  ],
  "ADMIN_ENTRY": [
    {
      "name": "data",
      "typeName": "ITEM_STRUCTURE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Content of the Admin Entry."
    }
  ],
  "CARE_ENTRY": [
    {
      "name": "guideline_id",
      "typeName": "OBJECT_REF",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional external identifier of guideline creating this Entry if relevant."
    },
    {
      "name": "protocol",
      "typeName": "ITEM_STRUCTURE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Description of the method (i.e. how) the information in this entry was arrived at. For `OBSERVATIONs`, this is a description of the method or instrument used. For `EVALUATIONs`, how the evaluation was arrived at. For `INSTRUCTIONs`, how to execute the Instruction. This may take the form of references to guidelines, including manually followed and executable; knowledge references such as a paper in Medline; clinical reasons within a larger care process. "
    }
  ],
  "OBSERVATION": [
    {
      "name": "data",
      "typeName": "HISTORY<ITEM_STRUCTURE>",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The data of this observation, in the form of a history of values which may be of any complexity."
    },
    {
      "name": "state",
      "typeName": "HISTORY<ITEM_STRUCTURE>",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional recording of the state of subject of this observation during the observation process, in the form of a separate history of values which may be of any complexity. State may also be recorded within the History of the data attribute. "
    }
  ],
  "EVALUATION": [
    {
      "name": "data",
      "typeName": "ITEM_STRUCTURE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "The data of this evaluation, in the form of a spatial data structure."
    }
  ],
  "ACTION": [
    {
      "name": "description",
      "typeName": "ITEM_STRUCTURE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Description of the action that has been performed, in the form of an archetyped structure."
    },
    {
      "name": "instruction_details",
      "typeName": "INSTRUCTION_DETAILS",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Details of the Instruction that caused this Action to be performed, if there was one."
    },
    {
      "name": "ism_transition",
      "typeName": "ISM_TRANSITION",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Details of transition in the Instruction state machine caused by this Action."
    },
    {
      "name": "time",
      "typeName": "DV_DATE_TIME",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Point in time at which this action completed. To indicate an unknown time, use a `DV_DATE_TIME` instance with `_value_` set to the time of creation (or some other known time before which the Action is known to have occurred, e.g. data accession timestamp from integration engine), and `_magnitude_status_` set to `<`."
    }
  ],
  "ACTIVITY": [
    {
      "name": "action_archetype_id",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Perl-compliant regular expression pattern, enclosed in  '//' delimiters, indicating the valid identifiers of archetypes for Actions corresponding to this Activity specification. \n\nDefaults to  `/.*/`, meaning any archetype."
    },
    {
      "name": "description",
      "typeName": "ITEM_STRUCTURE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Description of the activity, in the form of an archetyped structure."
    },
    {
      "name": "timing",
      "typeName": "DV_PARSABLE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Timing of the activity, in the form of a parsable string. If used, the preferred syntax is ISO8601 'R' format, but other formats may be used including HL7 GTS.\n\nMay be omitted if:\n\n* timing is represented structurally in the `_description_` attribute (e.g. via archetyped elements), or\n* unavailable, e.g. imported legacy data; in such cases, the `INSTRUCTION._narrative_` should carry text that indicates the timing of its `_activities_`."
    }
  ],
  "ISM_TRANSITION": [
    {
      "name": "careflow_step",
      "typeName": "DV_CODED_TEXT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The step in the careflow process which occurred as part of generating this action, e.g.  dispense ,  start_administration. This attribute represents the clinical  label for the activity, as  opposed to current_state which represents  the state machine (ISM)  computable form. Defined in archetype."
    },
    {
      "name": "current_state",
      "typeName": "DV_CODED_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "The ISM current state. Coded by openEHR terminology group Instruction states."
    },
    {
      "name": "reason",
      "typeName": "List<DV_TEXT>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional possibility of adding one or more reasons for this careflow step having been taken. Multiple reasons may occur in medication management for example."
    },
    {
      "name": "transition",
      "typeName": "DV_CODED_TEXT",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "The ISM transition which occurred to arrive in the current_state. Coded by openEHR terminology group  Instruction transitions."
    }
  ],
  "INSTRUCTION_DETAILS": [
    {
      "name": "activity_id",
      "typeName": "String",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Identifier of Activity within Instruction, in the form of its archetype path. "
    },
    {
      "name": "instruction_id",
      "typeName": "LOCATABLE_REF",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Reference to causing Instruction."
    },
    {
      "name": "wf_details",
      "typeName": "ITEM_STRUCTURE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Various workflow engine state details, potentially including such things as:\n\n* condition that fired to cause this Action to be done (with actual variables substituted); \n* list of notifications which actually occurred (with all variables substituted); \n* other workflow engine state. \n\nThis specification does not currently define the actual structure or semantics of this field. \n"
    }
  ],
  "ENTRY": [
    {
      "name": "encoding",
      "typeName": "CODE_PHRASE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Name of character set in which text values in this Entry are encoded. Coded from openEHR Code Set  character sets."
    },
    {
      "name": "language",
      "typeName": "CODE_PHRASE",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Mandatory indicator of the localised language in which this Entry is written. Coded from openEHR Code Set  languages . "
    },
    {
      "name": "other_participations",
      "typeName": "List<PARTICIPATION>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Other participations at `ENTRY` level. "
    },
    {
      "name": "provider",
      "typeName": "PARTY_PROXY",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": true,
      "documentation": "Optional identification of provider of the information in this `ENTRY`, which might be: \n\n* the patient \n* a patient agent, e.g. parent, guardian \n* the clinician \n* a device or software \n\nGenerally only used when the recorder needs to make it explicit. Otherwise, Composition composer and other participants are assumed. \n"
    },
    {
      "name": "subject",
      "typeName": "PARTY_PROXY",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": true,
      "documentation": "Id of human subject of this `ENTRY`, e.g.: \n\n* organ donor \n* foetus \n* a family member \n* another clinically relevant person."
    },
    {
      "name": "workflow_id",
      "typeName": "OBJECT_REF",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Identifier of externally held workflow engine data for this workflow execution, for this subject of care."
    }
  ],
  "INSTRUCTION": [
    {
      "name": "activities",
      "typeName": "List<ACTIVITY>",
      "min": 0,
      "max": null,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "List of all activities in Instruction. \n"
    },
    {
      "name": "expiry_time",
      "typeName": "DV_DATE_TIME",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional expiry date/time to assist determination of when an Instruction can be assumed to have expired. This helps prevent false listing of Instructions as Active when they clearly must have been terminated in some way or other. "
    },
    {
      "name": "narrative",
      "typeName": "DV_TEXT",
      "min": 1,
      "max": 1,
      "mandatory": true,
      "polymorphic": false,
      "documentation": "Mandatory human-readable version of what the Instruction is about. "
    },
    {
      "name": "wf_definition",
      "typeName": "DV_PARSABLE",
      "min": 0,
      "max": 1,
      "mandatory": false,
      "polymorphic": false,
      "documentation": "Optional workflow engine executable expression of the Instruction. "
    }
  ]
};
